import React from 'react';
import CommonEpicLinkField from '@atlassian/jira-issue-create-commons/src/ui/epic-link-field/index.tsx';
import type { Props } from './types';

export const EpicLinkField = (props: Props) => {
	const { useFormContext, ...commonEpicLinkFieldProps } = props;
	const [, { setIsEpicLinkSelected }] = useFormContext();
	return (
		<CommonEpicLinkField
			{...commonEpicLinkFieldProps}
			setIsEpicLinkSelected={setIsEpicLinkSelected}
		/>
	);
};
